import { render, staticRenderFns } from "./updHsftHsfo.vue?vue&type=template&id=a35bde12&scoped=true"
import script from "./updHsftHsfo.vue?vue&type=script&lang=js"
export * from "./updHsftHsfo.vue?vue&type=script&lang=js"
import style0 from "./updHsftHsfo.vue?vue&type=style&index=0&id=a35bde12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35bde12",
  null
  
)

export default component.exports